<template>
  <div class="container">
    <div class="school-body-works-student">
      <el-row>
        <el-col :span="24">
          <div class="classwrapper">
            <el-row>
              <el-col :span="24">
                <div class="coursework">
                  <el-tabs v-model="activeName" @tab-click="handleClickTab">
                    <el-tab-pane label="自由创作" name="second">
                      <el-form
                        ref="form"
                        :model="FreeworkForm"
                        inline
                        size="mini"
                      >
                        <el-form-item label="所属科目">
                          <el-select
                            v-model="FreeworkForm.subject_code"
                            placeholder="请选择科目"
                            style="width: 100px"
                            filterable
                          >
                            <el-option
                              :label="item.name"
                              :value="item.code"
                              v-for="(item, index) of subjectList"
                              :key="index"
                            ></el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="作品名称">
                          <el-input
                            clearable
                            style="width: 200px"
                            v-model="FreeworkForm.title"
                            placeholder="请输入作品名称"
                          ></el-input>
                        </el-form-item>

                        <el-form-item size="mini">
                          <el-button
                            type="primary"
                            @click="stuGetClassmateWorkList"
                            >查询</el-button
                          >
                        </el-form-item>
                      </el-form>

                      <el-row :gutter="20">
                        <el-col
                          :span="25"
                          v-for="item of FreeWorkList"
                          :key="item.id"
                        >
                          <el-card shadow="never">
                            <div class="worklist">
                              <div
                                class="worklist_imgwrapper"
                                @click="LookWork(item)"
                              >
                                <el-image
                                  class="workimg"
                                  :src="item.covers"
                                  fit="fill"
                                ></el-image>
                              </div>

                              <div class="work_title">
                                <el-row>
                                  <el-col :span="17">
                                    <div>
                                      <el-tooltip
                                        class="item"
                                        effect="dark"
                                        :content="item.title"
                                        placement="top-start"
                                      >
                                        <span class="work_title_span">{{
                                          item.title.slice(0, 10)
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </el-col>
                                </el-row>

                                <span
                                  style="margin-left: 5px"
                                  class="el-icon-thumb"
                                >
                                  <span style="margin-left: 5px">{{
                                    item.zan
                                  }}</span>
                                </span>
                                <span
                                  style="margin-left: 10px"
                                  class="el-icon-view"
                                  ><span style="margin-left: 5px">{{
                                    item.looks
                                  }}</span></span
                                >
                              </div>

                              <div>
                                <el-row>
                                  <el-col :span="4">
                                    <div class="work_stuinfo">
                                      <el-avatar
                                        size="small"
                                        class="work_stuinfo_avatar"
                                        :src="item.headImgUrl"
                                      ></el-avatar>
                                    </div>
                                  </el-col>
                                  <el-col :span="8">
                                    <div class="work_stuinfo_name">
                                      <span class="work_stuinfo_name_span">{{
                                        item.name
                                      }}</span>
                                    </div>
                                  </el-col>
                                </el-row>
                              </div>
                            </div>
                          </el-card>
                        </el-col>
                      </el-row>

                      <div style="margin: 20px; text-align: right">
                        <el-pagination
                          @current-change="handleCurrentChange"
                          :current-page="page_no"
                          :page-size="page_size"
                          layout="total, prev, pager, next, jumper"
                          :total="total"
                        >
                        </el-pagination>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>

      <!--点评作业弹窗-->
      <el-dialog
        class="comment"
        title="作业点评"
        :visible.sync="dialogFormVisible"
      >
        <el-row>
          <el-col :span="14">
            <div class="grid-content bg-purple">
              <el-row>
                <el-col :span="24">
                  <div
                    style="font-size: 16px; font-weight: 500"
                    class="grid-content bg-purple-dark"
                  >
                    打地鼠
                  </div>
                </el-col>
              </el-row>

              <el-row style="margin-top: 10px">
                <el-col :span="2">
                  <div style="height: 30px; line-height: 30px">
                    <el-image
                      style="width: 30px; height: 30px; border-radius: 5px"
                      src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201502%2F08%2F20150208000701_KkwQ3.jpeg&refer=http%3A%2F%2Fb-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1616228927&t=6779d751da955d76573057876f3fb535"
                      fit="fill"
                    ></el-image>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div
                    style="line-height: 30px"
                    class="grid-content bg-purple-light"
                  >
                    小明
                  </div>
                </el-col>
                <el-col :span="10">
                  <div style="line-height: 30px" class="grid-content bg-purple">
                    发布于：2020/12/02
                  </div>
                </el-col>
                <el-col :span="10">
                  <div
                    style="line-height: 30px"
                    class="grid-content bg-purple-light"
                  >
                    更新于：2020/12/02
                  </div>
                </el-col>
              </el-row>

              <el-row style="margin-top: 20px">
                <el-col :span="1">
                  <div style="height: 15px; line-height: 15px">
                    <el-image
                      style="width: 15px; height: 15px"
                      src="https://scratch3.fun/static/assets/2e0c4790f8f9cf28e3c346b9cef0fcb6.svg"
                      fit="fill"
                    ></el-image>
                  </div>
                </el-col>

                <el-col :span="1">
                  <div style="height: 15px; line-height: 15px">
                    <el-image
                      style="width: 15px; height: 15px"
                      src="https://scratch3.fun/static/assets/36fcc7dbca20720abcab01e49d4955f9.svg"
                      fit="fill"
                    ></el-image>
                  </div>
                </el-col>
              </el-row>

              <iframe
                style="margin-top: 10px; border-radius: 5px"
                src="https://scratch3.fun"
                width="480"
                height="360"
              ></iframe>

              <el-row>
                <el-col :span="24">
                  <div
                    style="font-size: 14px; margin-top: 10px"
                    class="grid-content bg-purple-dark"
                  >
                    <ul>
                      <i style="margin-right: 20px" class="el-icon-view"
                        >源码</i
                      >
                      <i style="margin-right: 20px" class="el-icon-star-off"
                        >收藏</i
                      >
                      <i style="margin-right: 20px" class="el-icon-share"
                        >分享</i
                      >
                    </ul>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple-light">
              <el-row>
                <el-col :span="24">
                  <div
                    style="font-size: 16px; font-weight: 500"
                    class="grid-content bg-purple-dark"
                  >
                    开始点评
                  </div>
                </el-col>
              </el-row>

              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                label-position="top"
                size="mini"
                style="margin-top: 10px"
                class="demo-ruleForm"
              >
                <el-form-item label="作品等级" prop="delivery">
                  <el-rate v-model="value"> </el-rate>
                </el-form-item>
                <el-form-item label="作业推优" prop="delivery">
                  <el-switch v-model="ruleForm.delivery"></el-switch>
                </el-form-item>
                <el-form-item label="教师评语" prop="desc">
                  <el-tag style="margin-right: 10px" size="mini" type="info"
                    >很好,值得表扬!</el-tag
                  >
                  <el-tag style="margin-right: 10px" size="mini" type="info"
                    >不错,继续加油!</el-tag
                  >
                  <el-tag style="margin-right: 10px" size="mini" type="info"
                    >再接再厉!</el-tag
                  >
                  <el-tag style="margin-right: 10px" size="mini" type="info"
                    >还需要多多练习哦!</el-tag
                  >

                  <el-input
                    style="margin-top: 10px"
                    type="textarea"
                    v-model="ruleForm.desc"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitForm('ruleForm')"
                    >点评</el-button
                  >
                  <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  stuGetStuSubjectAuth,
  stuGetClassmateWorkList,
} from '@/api/classroom/student_api'

import { getZoneSchoolSubjectList } from '@/api/community'

export default {
  name: 'classlistWorksStudent',
  data() {
    return {
      value: null,
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        region: [
          { required: true, message: '请选择活动区域', trigger: 'change' },
        ],
        date1: [
          {
            type: 'date',
            required: true,
            message: '请选择日期',
            trigger: 'change',
          },
        ],
        date2: [
          {
            type: 'date',
            required: true,
            message: '请选择时间',
            trigger: 'change',
          },
        ],
        type: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个活动性质',
            trigger: 'change',
          },
        ],
        resource: [
          { required: true, message: '请选择活动资源', trigger: 'change' },
        ],
        desc: [{ required: true, message: '请填写活动形式', trigger: 'blur' }],
      },
      dialogFormVisible: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      formLabelWidth: '120px',
      gridData: [
        {
          date: '9:31',
          name: '王小虎',
          address: '正常',
        },
        {
          date: '9:50',
          name: '王小虎',
          address: '迟到',
        },
        {
          date: null,
          name: '王小虎',
          address: '缺勤',
        },
      ],

      workData: [
        {
          date: '9:31',
          name: '王小虎',
          address: '未提交',
          comment: '未评',
        },
        {
          date: '9:50',
          name: '王小虎',
          address: '已提交',
          comment: '未评',
        },
        {
          date: null,
          name: '王小虎',
          address: '已提交',
          comment: '已评',
        },
      ],

      tableData: [
        {
          date: '2016-05-02',
          account: 'jrcode',
          name: '王小虎',
          nickname: '小虎',
          age: '10',
          sex: '男',
          school: '马场道小学',
          grade: '二年级',
          mumnumber: '15522869972',
          dadnumber: '18722160681',
        },
        {
          date: '2016-05-02',
          account: 'jrcode',
          name: '王小虎',
          nickname: '小虎',
          age: '10',
          sex: '男',
          school: '马场道小学',
          grade: '二年级',
          mumnumber: '15522869972',
          dadnumber: '18722160681',
        },
        {
          date: '2016-05-02',
          account: 'jrcode',
          name: '王小虎',
          nickname: '小虎',
          age: '10',
          sex: '男',
          school: '马场道小学',
          grade: '二年级',
          mumnumber: '15522869972',
          dadnumber: '18722160681',
        },
        {
          date: '2016-05-02',
          account: 'jrcode',
          name: '王小虎',
          nickname: '小虎',
          age: '10',
          sex: '男',
          school: '马场道小学',
          grade: '二年级',
          mumnumber: '15522869972',
          dadnumber: '18722160681',
        },
      ],
      activeName: 'second',
      radio1: '上海',
      radio: '3',
      sizeForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      FreeworkForm: {
        subject_code: '',
        is_marking: '',
        title: '',
      },
      subjectList: [],
      FreeWorkList: [],
      page_no: 1,
      page_size: 20,
      total: 0,
    }
  },
  watch: {
    'FreeworkForm.subject_code': function() {
      this.stuGetClassmateWorkList()
    },
  },

  mounted() {
    this.stuGetStuSubjectAuth()
    // this.getZoneSchoolSubjectList()
  },

  methods: {
    onSubmit() {
      console.log('submit!')
    },
    handleClickTab(tab, event) {
      console.log(tab, event)
    },
    handleClick(row) {
      console.log(row)
    },

    handleEdit(row) {
      this.dialogFormVisible = true
      console.log(row)
    },
    handleClassClick() {
      console.log('班级信息')
      this.$router.push({
        name: 'classlistDescTeacher',
      })
    },
    //获取学校科目权限列表
    stuGetStuSubjectAuth() {
      console.log('查询学生科目权限')
      stuGetStuSubjectAuth().then((res) => {
        this.subjectList = res.subjectList
        console.log('获取科目权限权限列表')
        console.log(res)

        if (res.subjectList.length == 0) {
          this.$message.warning('无科目权限')
          return
        }

        this.FreeworkForm.subject_code = res.subjectList[0].code

        this.stuGetClassmateWorkList()
      })
    },

    getZoneSchoolSubjectList() {
      getZoneSchoolSubjectList().then((res) => {
        console.log('获得校区科目列表')
        console.log(res)
        this.subjectList = res.subjectList

        this.FreeworkForm.subject_code = res.subjectList[0].code

        this.stuGetClassmateWorkList()
      })
    },

    //获得班级同学自由创作作品

    stuGetClassmateWorkList() {
      stuGetClassmateWorkList({
        subject_code: this.FreeworkForm.subject_code,
        title: this.FreeworkForm.title,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('同学自由创作列表')
        console.log(res)
        let FreeWorkList1 = []
        FreeWorkList1 = res.workList
        FreeWorkList1.map((item) => {
          if (item.work_type === 1) {
            FreeWorkList1.splice(FreeWorkList1.indexOf(item), 1)
          }
        })

        this.FreeWorkList = FreeWorkList1

        this.total = res.total
      })
    },

    //跳转到作品详情页面
    LookWork(item) {
      console.log('跳转到作品详情页面')
      console.log(item)
      if (this.activeName == 'second') {
        console.log('自由创作作品列表')
        if (this.FreeworkForm.subject_code == '1') {
          console.log('自由创作-Jrcode1')

          window.location.href =
            '/jrcode/show.html?mode=look&filepath=' +
            item.work_url +
            '&work_id=' +
            item.id
        } else if (this.FreeworkForm.subject_code == '2') {
          console.log('自由创作-Scratch')

          window.location.href =
            '/community/project?work_id=' +
            item.id +
            '&subject_code=' +
            this.FreeworkForm.subject_code +
            '&path=classlistWorksStudent'
        } else if (this.FreeworkForm.subject_code == '3') {
          console.log('python作品编辑')
          console.log(item)
          console.log(item.id)

          window.location.href =
            '/python/editor?work_id=' + item.id + '&mode=look'
        }
      }
    },

    handleCurrentChange(val) {
      this.page_no = val
      this.stuGetClassmateWorkList()
    },
  },
}
</script>

<style>
.el-dialog {
  width: 900px;
}
</style>

<style lang="scss" scoped>
.school-body-works-student {
  margin: 10px;

  .classwrapper {
    border-radius: 5px;
    overflow-y: scroll;
    background: white;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    padding-top: 10px;
    min-height: calc(100vh - 110px);
    .el-col-25 {
      width: 20%;
      margin-bottom: 20px;
    }
    .worklist {
      background: white;
      border-radius: 15px;
      padding-bottom: 10px;
      .worklist_imgwrapper {
        width: 100%;
        height: 0;
        padding-bottom: 75%;
        cursor: pointer;
        .workimg /deep/ {
          box-sizing: border-box;
          width: 100%;
          padding: 10px;
          img {
            border-radius: 10px;
          }
        }
      }
      .work_title {
        padding-top: 10px;
        margin-left: 5px;
        .work_title_span {
          font-size: 14px;
          color: #606266;

          width: 90%;
          overflow: hidden; /*内容超出后隐藏*/
          text-overflow: ellipsis; /* 超出内容显示为省略号 */
          white-space: nowrap; /* 文本不进行换行 */
        }
      }

      .work_stuinfo {
        margin-left: 5px;
        .work_stuinfo_avatar {
          float: left;
        }
      }

      .work_stuinfo_name {
        .work_stuinfo_name_span {
          margin-left: 5px;
          line-height: 30px;
        }
      }
    }
  }

  .classwrapper::-webkit-scrollbar {
    display: none;
  }
}
</style>

<style>
.school-body-works-student .el-card__body {
  padding: 0px;
}
</style>
